import { render } from "./AccordionDudas.vue?vue&type=template&id=35a4a13c"
import script from "./AccordionDudas.vue?vue&type=script&lang=js"
export * from "./AccordionDudas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__